
const isEmpty = require('lodash/isEmpty')
const merge = require('lodash/merge')
const serverConfig = require('../../../infrastructure/serverConfig')

module.exports = [
  '$scope',
  'contactService',
  'contactListService',
  '$stateParams',
  '$state',
  '$utils',
  '$translate',
  '$window',
  'User',
  'LocalStorage',
  'Promise',
  'detailService',
  '$ionicPopup',
  '$rootScope',
  '$ionicHistory',
  '$location',
  '$q',
  function ($scope, contactService, contactListService, $stateParams, $state, $utils, $translate,
    $window, User, LocalStorage, Promise, detailService, $ionicPopup, $rootScope, $ionicHistory, $location, $q) {
    if ($state.current.name === 'frame.detail') {
      $scope.isLoading = true
      $scope.details = {
        starId: $stateParams.contactId,
        id: $stateParams.contactId,
        name: $stateParams.name,
      }
      $scope.dial = function (number) {
        if (number) $window.location.href = 'tel:' + number
      }
      $scope.handleItemClick = function(itemType) {
        switch (itemType) {
          case 'detail-email':
            $state.go('frame.compose', {action: 'compose', email: $scope.details.email})
            break
          case 'detail-dealings':
            if ($rootScope.settings.wechatMiniProgram) {
              uni.postMessage({
                data: {
                  mailDealing: { contactId: $scope.details.id, name: $scope.details.name }
                }
              })
              uni.redirectTo({
                url: '/pages/detail/detail'
              })
            } else {
              $state.go('frame.maildealings', {contactId: $scope.details.id, name: $scope.details.name})
            }
            break
          case 'detail-addToPab':
            window.backTarget = $ionicHistory.backView() && $ionicHistory.backView().url
            $state.go('frame.createContact', {type: 'addToPab', contactid: $scope.details.id, name: $scope.details.name})
            break
        }
      }
      /** get contact detail */

      // id是邮件地址需要先获取该邮件地址的id，否则oab:get无法获取外部联系人
      const contactDefer = $utils.$email.test($scope.details.id) ? contactService.searchOabContacts($scope.details.id) : $q.resolve($scope.details.id)
      contactDefer.then(function(contact) {
        if (!isEmpty(contact)) {
          /** local user */
          /** empty object when partial OK */
          merge($scope.details, contact[0])
          const {email, true_name: trueName} = $scope.details
          $scope.details.starId = $scope.details['@id'] || $scope.details.starId
          isStarMarked($scope.details.starId)
          $scope.avatarInfo = {email: email, name: trueName}
        } else {
        // 针对Oac:get接口返回S_PARTIAL_OK的情况
          isStarMarked($scope.details.starId)
          const {id, name} = $scope.details
          $scope.details.email = id
          $scope.avatarInfo = {email: id, name: name}
        }
        $scope.$broadcast('CONTACT_DETAIL.CONTENT_LOADED')
      }).finally(function () {
        /** default value */
        $scope.details.email = $scope.details.email || $scope.details.id
        /** only show when matching primary email */
        $scope.isShowDealings = $scope.details.email !== User.getConfig()['primary_email']
        $scope.isLoading = false
      })
    }
    if ($state.current.name === 'frame.personalContactDetail') {
      $scope.isPersonalDetail = true
      $scope.contactid = $stateParams.contactid
      $scope.groupid = $stateParams.groupid
      getPersonalContactDetail($stateParams.contactid)
    }
    // 根据contactid获取联系人详情
    function getPersonalContactDetail(contactid) {
      $scope.isLoading = true
      contactService.getContactDetail(contactid).then(function (detail) {
        if (detail.ORGNAME) [detail.orgName, detail.duty] = detail.ORGNAME.split('•')
        $scope.personalContactDetail = detail
        $scope.pabAvatarInfo = {id: detail.id, email: detail['EMAIL;PREF'], name: detail.FN, type: 'pabContact'}
        isStarMarked(detail.id)
        $scope.$broadcast('CONTACT_DETAIL.CONTENT_LOADED')
      }, function (error) {
        console.log(error)
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    // 删除联系人
    $scope.deleteContact = function () {
      const confirmPopup = $ionicPopup.confirm({
        template: $translate.instant('ADDRESSBOOK.DETAIL.CONFIRM_DELETE_CONTACT'),
        cancelText: $translate.instant('OP.CANCEL'),
        cancelType: 'button-positive',
        okText: $translate.instant('OP.CONFIRM'),
        okType: 'button-default'
      })
      confirmPopup.then(function (res) {
        if (res) {
          contactService.deleteContactById($stateParams.contactid).then(function (result) {
            if (result === 'success') {
              if ($rootScope.isAddrRootSearch || $rootScope.isPabSearch) {
                window.history.go(-1)
              } else {
                $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.DETAIL.DELETE_SUCCESSFULLY') })
              }
            }
          }, function () {
            $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.DETAIL.DELETE_FAILED') })
          }
          )
        }
      }, function () {
      })
    }
    $scope.dial = function (number) {
      if (number) $window.location.href = 'tel:' + number
    }
    // 打开写信页
    $scope.compose = function (email) {
      $state.go('frame.compose', { action: 'compose', email: email })
    }
    // 打开往来邮件页
    $scope.mailDealing = function (name, email) {
      $rootScope.pabMailDealing = true
      if ($rootScope.settings.wechatMiniProgram) {
        console.log({ contactId: email, name: name })
        uni.postMessage({
          data: {
            mailDealing: { contactId: email, name: name }
          }
        })
        uni.redirectTo({
          url: '/pages/detail/detail'
        })
      } else {
        $state.go('frame.maildealings', { contactId: email, name: name })
      }
    }
    // 判断是否是星标联系人
    function isStarMarked(id) {
      $scope.isStarMarked = contactService.isStarDeptContact({ type: 'contact', id: id })
    }
    // 设为星标联系人
    $scope.markStar = function (id, name, email, groupid) {
      let payload
      if ($scope.isPersonalDetail) {
        payload = {
          id: id,
          name: name,
          email: email,
          groupid: groupid
        }
      } else {
        payload = {
          id: id,
          name: name,
          email: email,
        }
      }
      contactService.markStar({ type: 'contact', payload: payload }).then(function () {
        $scope.isStarMarked = true
      }, function () {
      })
    }
    // 取消星标联系人
    $scope.cancelStar = function (id) {
      contactService.removeStar({ type: 'contact', id: id }).then(function () {
        $scope.isStarMarked = false
      }, function () {
      })
    }
    // 返回
    $scope.goBack = function () {
      if (window.backTarget) {
        const target = window.backTarget
        window.backTarget = null
        $location.url(target)
      } else {
        window.history.back()
      }
    }
    // 通讯录的显示隐藏配置
    $scope.ldvcappShow = serverConfig.contactsAttrShow('ldvcapp')
    $scope.oabShow = serverConfig.contactsAttrShow('oab')
  }]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/detail/detailCtrl.js